export interface MetricProgress {
    completed: number;
    target: number;
    projected: number;
}

export const computeMetricProgress = (
    completed: number,
    target: number,
    projectedMonthly: number,
    daysInMonth: number,
    dayOfMonth: number,
): MetricProgress => {
    const remainingDays = daysInMonth - dayOfMonth;
    const dailyPlanRate = projectedMonthly / daysInMonth;
    return {
        completed,
        target,
        projected: Math.round(completed + dailyPlanRate * remainingDays),
    };
};
